module.exports = __webpack_public_path__ + "static/img/flowone.cc4b8bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flowone.png
// module id = NI/Q
// module chunks = 29